<template lang="pug">
  b-modal.form-modal(:active="active" has-modal-card)
    .modal-card.form-component
      .modal-card-head
        .modal-card-title(v-if="title") {{ title }}
      .modal-card-body
        form-component(:form="form" v-bind="$attrs" v-on="$listeners")
      .modal-card-foot
        b-button(type="is-primary" @click="$emit('save')") Сохранить
        b-button(type="is-light" @click="$emit('close')") Отмена
</template>

<script>
import BButton from 'buefy/src/components/button/Button';

export default {
  name: 'form-modal',
  components: { BButton },
  props: {
    active: Boolean,
    form: String,
    title: String,
  },
};
</script>

<style scoped></style>
